module.exports = __webpack_public_path__ + "img/close_icon.25558741.svg";